interface TrailerWarningsProps {
  warnings: string[]
  savedAt?: string | null
}

export function TrailerWarnings({ warnings, savedAt }: TrailerWarningsProps) {
  return (
    <div className="space-y-2">
      {warnings.map((w, i) => (
        <div key={i} className="flex items-start gap-2 bg-amber-50 border border-amber-200 text-amber-800 text-sm px-3 py-2 rounded-lg">
          <span className="mt-0.5 shrink-0">⚠️</span>
          <span>{w}</span>
        </div>
      ))}
      {savedAt && (
        <div className="text-xs text-green-700 bg-green-50 border border-green-200 px-3 py-2 rounded-lg">
          ✅ Layout saved at {new Date(savedAt).toLocaleTimeString()}
        </div>
      )}
    </div>
  )
}
